const purchasingUser = {
    isLoading: {
        basicInfo: false,
        supplierAddresses: false,
        wholesalerResellerList: false,
        addressList: false,
        picNumberList: false,
        creditCardList: false,
    },
    loggedIn: true, // always logged in
    initialized: false,
    supplierInfo: {},

    info: {
        basicInfo: {},
        availableWholesalerReseller: [],
        availablePICNumbers: [],
        availableCreditCards: [],
        availableAddresses: [],
    },

    type: 'retail-customer',
};
const PurchasingUserReducer = function(state = purchasingUser, action) {
    switch (action.type) {
        case 'TOGGLE_PURCHASING_USER_LOADING': {
            return {
                ...state,
                isLoading: {
                    ...state.isLoading,
                    [action.key]: action.value,
                },
            };
        }
        case 'SET_PURCHASING_USER_INITIALIZED': {
            return {
                ...state,
                initialized: action.value,
            };
        }
        case 'SET_PURCHASING_USER_MEMBER_TYPE': {
            return {
                ...state,
                type: action.value,
            };
        }
        case 'SET_PURCHASING_USER_INFO': {
            return {
                ...state,
                info: {
                    ...state.info,
                    ...action.value,
                },
            };
        }
        case 'SET_PURCHASING_USER_SUPPLIER_INFO': {
            return {
                ...state,
                supplierInfo: {
                    ...state.supplierInfo,
                    [action.id]: {
                        ...state.supplierInfo[action.id],
                        ...action.value,
                    },
                },
            };
        }
        case 'SET_PURCHASING_USER_ADDRESSES': {
            return {
                ...state,
                addresses: action.value,
            };
        }
        default: {
            return state;
        }
    }
};

export default PurchasingUserReducer;
